import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { storeAPI } from '../../services/api';
import { useCart } from '../../context/CartContext';
import { Search, ArrowLeft } from 'lucide-react';
import ProductCard from '../../components/store/ProductCard';

const SearchResults = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const query = searchParams.get('q') || '';
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const { addItem } = useCart();

  useEffect(() => {
    if (!query) return;
    setLoading(true);
    storeAPI.search(query)
      .then((res) => setProducts(res.data))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, [query]);

  const handleAddToCart = async (product) => {
    try { await addItem(product.id); } catch { navigate('/login'); }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <button onClick={() => navigate('/store')} className="flex items-center gap-2 text-gray-600 dark:text-gray-300 hover:text-orange-600 mb-6">
        <ArrowLeft className="w-4 h-4" /> Volver
      </button>
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2 flex items-center gap-2">
        <Search className="w-6 h-6" /> Resultados para: "{query}"
      </h1>
      <p className="text-gray-500 dark:text-gray-400 mb-8">{products.length} producto(s) encontrado(s)</p>
      {loading ? (
        <div className="flex justify-center py-20"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-600" /></div>
      ) : products.length === 0 ? (
        <div className="text-center py-20 text-gray-500">No se encontraron productos</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {products.map((product) => (
            <ProductCard key={product.id} product={product} onAddToCart={handleAddToCart} />
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchResults;
